const contrastRatio = (luminosity1: number, luminosity2: number) =>
  luminosity1 > luminosity2
    ? (luminosity2 + 0.05) / (luminosity1 + 0.05)
    : (luminosity1 + 0.05) / (luminosity2 + 0.05);

export default contrastRatio;
